import React from 'react';
import { Button, Modal } from '@attentive-platform/stem-ui';

export default function SOPAddAllTradesModal({ show, onClose, onConfirm }) {
  return (
    <Modal
      show={show}
      heading={<span className='pl-4'>Add all trades and items</span>}
      onClose={onClose}
      content={
        <div className='flex flex-col gap-2 m-3 w-[360px]'>
          <div className='text-sm sop-warning-text'>
            This will add all trades and select all items within each trade. Proceed?
          </div>
          <div className='text-xs sop-warning-text'>(use with extreme caution - for internal accounts only)</div>
          <div className='flex justify-end gap-2 mt-4'>
            <Button size='medium' variant='outlined' onClick={onClose}>
              Cancel
            </Button>
            <Button color='secondary' size='medium' onClick={onConfirm}>
              Confirm
            </Button>
          </div>
        </div>
      }
    />
  );
} 